export class User {
    id: number;
    username: string;
    password: string;
    firstName: string;
    lastName: string;
}


// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/_models/user.ts